<div fxLayout="column" fxLayoutAlign="start start" class="margin-bottom-1rem">
  <div class="forge-typography--heading2">
    {{group}}
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start start" class="group-keys">
    @for (shortcut of shortcuts; track shortcut) {
      <forge-label-value>
        <span slot="label">{{shortcut.Keys}}</span>
        <span slot="value">{{shortcut.Description}}</span>
      </forge-label-value>
    }
  </div>
</div>
